import { useFlags } from 'launchdarkly-react-client-sdk';
import { Text } from '@spark-web/text';
import { TextLinkButton } from '@spark-web/text-link';
import { useAssistantSafe } from './AssistantProvider';
import { ASSISTANT_FLAG_KEY, ASSISTANT_HANDOFF_LINK, ASSISTANT_HANDOFF_PROMPT } from './constants';

/**
 * The error → assistant hand-off. Renders nothing unless the assistant is
 * mounted and live on the current step, so call sites need no gating of
 * their own (and tests without the provider are unaffected).
 *
 * Inline prose rather than a button: the panel it opens is for follow-up questions once the error
 * copy above has already said what went wrong, so it should not compete with the upload action.
 */
export function ExplainErrorButton({
  errorMessage,
  displayMessage,
  stepKey,
  question,
}: {
  errorMessage: string;
  displayMessage?: string;
  stepKey: string;
  /** Asked on the customer's behalf when the panel opens. See ERROR_HANDOFF_QUESTIONS. */
  question?: string;
}) {
  const flags = useFlags<Record<string, boolean>>();
  const assistant = useAssistantSafe();

  if (!flags[ASSISTANT_FLAG_KEY] || !assistant?.isEnabledOnStep) {
    return null;
  }

  return (
    <Text size="standard">
      {`${ASSISTANT_HANDOFF_PROMPT} `}
      <TextLinkButton
        tone="primaryActive"
        weight="regular"
        data={{ testid: 'assistant-explain-error' }}
        onClick={() => assistant.openWithError({ message: errorMessage, displayMessage, stepKey, question })}
      >
        {ASSISTANT_HANDOFF_LINK}
      </TextLinkButton>
    </Text>
  );
}
